import { render, staticRenderFns } from "./DealerManagement.vue?vue&type=template&id=bc26d930&scoped=true"
import script from "./DealerManagement.vue?vue&type=script&lang=js"
export * from "./DealerManagement.vue?vue&type=script&lang=js"
import style0 from "./DealerManagement.vue?vue&type=style&index=0&id=bc26d930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc26d930",
  null
  
)

export default component.exports